import React from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../images/logo.png'
import { SettingOutlined } from '@ant-design/icons'
import theme from '../theme';
import CartIcon from './CartIcon';
import { useUser } from '../contexts/UserContext';

const Header: React.FC = () => {
    const navigate = useNavigate()
    const { user, isStandardUser, logout } = useUser()

    // Gate visibility on the loaded user object, not on a localStorage
    // token snapshot, so the buttons hide immediately during loading,
    // logout, and any other state where `user` is null. External API
    // candidates (is_external_api_user=true) never see user-specific
    // actions in the header.
    const isExternal = !!user?.is_external_api_user;
    const showUserActions = !!user && !isExternal;

    const handleLogout = async () => {
        await logout();
        navigate('/login')
    }

    const handleLogoClick = () => {
        // External (B2B) users have no dashboard to navigate to; the logo
        // is a static brand mark for them. Same treatment while user is
        // null (loading or logged out) so the click is a no-op.
        if (isExternal || !user) return
        if (isStandardUser()) {
            navigate('/test-dashboard')
        } else {
            navigate('/dashboard')
        }
    }
    return (
        <header className="sticky-top header">
            <div className="container-fluid">
                <div
                    className="logo"
                    onClick={handleLogoClick}
                    style={{ cursor: (isExternal || !user) ? 'default' : 'pointer' }}
                >
                    <img src={logo} alt="Logo" style={{ height: '20px' }} />
                </div>
                <div className="fl_right" style={{ display: 'flex' }}>
                    {showUserActions && (
                        <>
                            {isStandardUser() && <CartIcon />}
                            <button className="header_btn" onClick={() => navigate('/user-settings')}>
                                <SettingOutlined className="header_settings" />
                            </button>
                            <button onClick={handleLogout} className="header_btn">
                                Logout
                            </button>
                        </>
                    )}
                </div>
            </div>
        </header>
    )
}

const headerStyle: React.CSSProperties = {
    background: theme.colors.primary,
    padding: '1rem',
    display: 'flex',
    justifyContent: 'space-between'
}


export default Header
